import Immutable from 'immutable';
import {getTiles} from "../../containers/DashboardPage/tiles";
import _flatten from 'lodash/flatten';
import _uniq from 'lodash/uniq';

const tiles = getTiles(() => {});

const findTile = type => tiles.find(t => t.type === type);

const DashboardModel = Immutable.Record({
  id: 0,
  name: '',
  tiles: [],
  data: {},
  locked: false,
  templateAccountId: 0,
});

export default class Dashboard extends DashboardModel {
  id: number;
  name: string;
  tiles: Object[];
  data: Object;
  locked: boolean;

  get wsTopics() {
    return _uniq(_flatten(Object.values(this.data)
        .map(d => findTile(d.type))
        .map(t => t.wsTopics)));
  }

  uuid() {
    return Date.now().toString();
  }

  clone() {
    return this.set('id', this.get('id'));
  }

  createTemplate() {
    const data = {};
    Object.entries(this.get('data')).forEach(([key, value]) => {
      const tile = findTile(value.type);
      const sanitize = tile?.sanitizeForTemplate || (c => c);
      data[key] = {...value, config: sanitize(value.config || {})};
    });
    return this.set('id', 0).set('data', data);
  }

  createCopyForLoad() {
    return this.set('id', 0).set('name', `${this.get('name')} [2]`);
  }

  tilesNeedingConfiguration() {
    const data = this.get('data') || {};
    return Object.entries(data)
        .filter(([, value]) => {
          const tile = findTile(value.type);
          return tile?.needsConfiguration?.(value.config || {});
        })
        .map(([key]) => key);
  }

}
